import { NgModule } from '@angular/core';
import {
  MatInputModule, MatFormFieldModule, MatStepperModule,
  MatDatepickerModule, MatNativeDateModule, MatRadioModule, MatCheckboxModule, MatProgressSpinnerModule
} from '@angular/material';



@NgModule({
  declarations: [],
  imports: [
    MatInputModule,
    MatFormFieldModule,
    MatStepperModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatCheckboxModule,
    MatProgressSpinnerModule
  ],
  exports: [
    MatInputModule,
    MatFormFieldModule,
    MatStepperModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatCheckboxModule,
    MatProgressSpinnerModule
  ],
  providers: [
    MatDatepickerModule
  ]
})
export class MaterialFormsModule { }
